import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { card, input, label, btnPrimary, h1 } from "./ui";
import { Save, Loader2, Megaphone } from "lucide-react";

export default function Integracoes() {
  const [ads, setAds] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/ads").then(({ data }) => setAds(data))
      .catch(() => setAds({ enabled: false, tag_id: "", conversion_id: "", conversion_label: "" }));
  }, []);

  if (!ads) return <Loader2 className="w-6 h-6 animate-spin text-[#5B6E5B]" />;

  const set = (k, v) => setAds({ ...ads, [k]: v });

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/ads", {
        enabled: !!ads.enabled, tag_id: ads.tag_id || "",
        conversion_id: ads.conversion_id || "", conversion_label: ads.conversion_label || "",
      });
      toast.success("Integração do Google Ads atualizada!");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao salvar.");
    }
    setSaving(false);
  };

  return (
    <div data-testid="integracoes-page" className="max-w-3xl">
      <p className="font-body text-xs tracking-[0.35em] uppercase text-[#C87A5E]">Integrações</p>
      <h1 className={h1}>Integrações</h1>

      <div className={`${card} p-6 sm:p-8 mt-8 space-y-5`} data-testid="google-ads-card">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center gap-3">
            <Megaphone className="w-5 h-5 text-[#5B6E5B]" />
            <h2 className="font-display text-2xl text-[#2C332A]">Google Ads</h2>
          </div>
          <label className="flex items-center gap-3 cursor-pointer select-none">
            <input type="checkbox" checked={!!ads.enabled} onChange={(e) => set("enabled", e.target.checked)}
              className="w-4 h-4 accent-[#5B6E5B]" data-testid="ads-enabled-toggle" />
            <span className="font-body text-sm text-[#4A5D4E]">Integração ativa</span>
          </label>
        </div>

        <div>
          <label className={label}>ID da tag Google Ads</label>
          <input className={input} value={ads.tag_id || ""} onChange={(e) => set("tag_id", e.target.value)}
            placeholder="AW-00000000000" data-testid="ads-tag-id" />
          <p className="font-body text-xs text-[#7A8A7A] mt-1.5">
            A tag oficial é carregada uma única vez nas páginas públicas, com consentimento negado por padrão (sem cookies de publicidade).
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <label className={label}>Identificador da conversão (WhatsApp)</label>
            <input className={input} value={ads.conversion_id || ""} onChange={(e) => set("conversion_id", e.target.value)}
              placeholder="AW-00000000000" data-testid="ads-conversion-id" />
          </div>
          <div>
            <label className={label}>Rótulo da conversão (WhatsApp)</label>
            <input className={input} value={ads.conversion_label || ""} onChange={(e) => set("conversion_label", e.target.value)}
              placeholder="Será fornecido pelo Google Ads" data-testid="ads-conversion-label" />
          </div>
        </div>
        <p className="font-body text-xs text-[#7A8A7A] -mt-2">
          A medição de cliques nos botões de WhatsApp já está preparada: a conversão só é enviada quando o identificador e o rótulo estiverem preenchidos. Nenhum dado pessoal ou de saúde é enviado ao Google.
        </p>

        <div>
          <button className={btnPrimary} onClick={save} disabled={saving} data-testid="ads-save-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Salvar
          </button>
        </div>
      </div>
    </div>
  );
}
